import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconDownload: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" {...props}>
        <g transform="translate(2 2)" fill="currentColor" fillRule="nonzero">
            <path d="M3 9a1 1 0 0 1 1 1v8h16v-8a1 1 0 1 1 2 0v8.004C22 19.005 21.247 20 20.104 20H3.896C2.753 20 2 19.005 2 18.004V10a1 1 0 0 1 1-1zm9-5a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1z" />
            <path d="M7.106 11.553a1 1 0 0 1 1.342-.447L12 12.882l3.553-1.776a1 1 0 0 1 .894 1.789l-4 2a1 1 0 0 1-.894 0l-4-2a1 1 0 0 1-.447-1.342z" />
        </g>
    </Icon>
);
